module.exports = __webpack_public_path__ + "img/jact.a94186bd.jpg";